import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

export default function TermsPage() {
  const { i18n } = useTranslation();
  const isSpanish = i18n.language === 'es';

  return (
    <>
      <SEO page="terms" />

      <div className="min-h-screen bg-slate-50 pt-20">
        <section className="bg-gradient-to-br from-orange-500 to-orange-600 py-16">
          <div className="max-w-4xl mx-auto px-4 text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {isSpanish ? 'Términos y Condiciones' : 'Terms & Conditions'}
            </h1>
            <p className="text-orange-100">
              {isSpanish ? 'Última actualización: Febrero 2026' : 'Last updated: February 2026'}
            </p>
          </div>
        </section>

        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-slate max-w-none">
            
            {isSpanish ? (
              <>
                <h2>1. Aceptación de los Términos</h2>
                <p>
                  Al acceder o utilizar la plataforma Hambre ("Servicio"), aceptas quedar vinculado por estos Términos y Condiciones 
                  ("Términos"). Si no estás de acuerdo con estos Términos, por favor no uses nuestro Servicio.
                </p>

                <h2>2. Descripción del Servicio</h2>
                <p>
                  Hambre proporciona una plataforma en línea que conecta a los clientes con restaurantes para pedidos de comida y entrega. 
                  Actuamos como intermediario entre tú y nuestros restaurantes asociados. No preparamos comida nosotros mismos.
                </p>
                <p>
                  Para socios restauranteros, también ofrecemos Hambre OS - nuestro Sistema Operativo para Restaurantes que incluye 
                  funcionalidades de Punto de Venta (POS), Pantalla de Cocina (KDS), gestión de inventario, programas de fidelidad, 
                  informes de fin de día, configuración de impresoras y otras herramientas de gestión empresarial.
                </p>

                <h2>3. Registro de Cuenta</h2>
                <h3>3.1 Creación de Cuenta</h3>
                <p>
                  Para usar ciertas funciones, debes crear una cuenta. Aceptas proporcionar información precisa, actual y completa 
                  y actualizar esta información para mantenerla exacta.
                </p>
                <h3>3.2 Seguridad de la Cuenta</h3>
                <p>
                  Eres responsable de mantener la confidencialidad de las credenciales de tu cuenta y de todas las actividades 
                  bajo tu cuenta. Notifícanos inmediatamente de cualquier acceso no autorizado.
                </p>

                <h2>4. Pedidos y Pagos</h2>
                <h3>4.1 Realizar Pedidos</h3>
                <p>
                  Cuando realizas un pedido, haces una oferta de compra al restaurante. El restaurante puede aceptar o 
                  rechazar tu pedido. Los pedidos son vinculantes una vez confirmados por el restaurante.
                </p>
                <h3>4.2 Precios y Pagos</h3>
                <ul>
                  <li>Los precios mostrados incluyen IVA donde corresponda.</li>
                  <li>Los costos de entrega y cargos por servicio se muestran antes del pago.</li>
                  <li>El pago se procesa al momento del pedido para entregas a domicilio.</li>
                  <li>Aceptamos las principales tarjetas de crédito y débito.</li>
                </ul>
                <h3>4.3 Reembolsos y Cancelaciones</h3>
                <p>
                  Los reembolsos pueden emitirse para pedidos no entregados o significativamente diferentes de lo ordenado. 
                  Las solicitudes de cancelación deben hacerse rápidamente y están sujetas a la aceptación del restaurante.
                </p>

                <h2>5. Entrega</h2>
                <h3>5.1 Tiempos de Entrega</h3>
                <p>
                  Los tiempos de entrega estimados son indicativos y no están garantizados. Pueden ocurrir retrasos debido al tráfico, 
                  clima u otros factores fuera de nuestro control.
                </p>
                <h3>5.2 Áreas de Entrega</h3>
                <p>
                  La disponibilidad de entrega depende de tu ubicación y la cobertura del restaurante. Debes proporcionar 
                  información precisa de la dirección de entrega.
                </p>
                <h3>5.3 Entregas Fallidas</h3>
                <p>
                  Si la entrega falla debido a dirección incorrecta, destinatario no disponible u otras razones relacionadas con el cliente, 
                  es posible que no tengas derecho a un reembolso.
                </p>

                <h2>6. Conducta del Usuario</h2>
                <p>Aceptas no:</p>
                <ul>
                  <li>Usar el Servicio para cualquier propósito ilegal</li>
                  <li>Suplantar a otros o proporcionar información falsa</li>
                  <li>Interferir con el funcionamiento adecuado del Servicio</li>
                  <li>Intentar obtener acceso no autorizado a cualquier sistema</li>
                  <li>Participar en comportamiento abusivo hacia el personal, restaurantes o repartidores</li>
                  <li>Usar el Servicio con fines comerciales sin permiso</li>
                </ul>

                <h2>7. Socios Restauranteros</h2>
                <p>
                  Los restaurantes en nuestra plataforma son negocios independientes. Son responsables de:
                </p>
                <ul>
                  <li>Calidad, seguridad e higiene de los alimentos</li>
                  <li>Exactitud de las descripciones del menú y precios</li>
                  <li>Cumplimiento de las regulaciones alimentarias</li>
                  <li>Manejo de información de alérgenos</li>
                </ul>
                <p>
                  Hambre no es responsable de problemas derivados de la preparación de alimentos o servicio del restaurante.
                </p>

                <h2>8. Términos de Hambre OS</h2>
                <h3>8.1 Licencia de Software</h3>
                <p>
                  Se otorga a los socios restauranteros una licencia limitada, no exclusiva, intransferible para usar Hambre OS 
                  durante la duración de la suscripción. Esta licencia no incluye ningún derecho de propiedad sobre el software.
                </p>
                <h3>8.2 Uso Aceptable</h3>
                <p>Los usuarios de Hambre OS aceptan:</p>
                <ul>
                  <li>Usar el sistema solo para fines legítimos de operación de restaurantes</li>
                  <li>Mantener la seguridad de las credenciales de acceso</li>
                  <li>No intentar ingeniería inversa ni modificar el software</li>
                  <li>No compartir el acceso con personas o entidades no autorizadas</li>
                </ul>
                <h3>8.3 Responsabilidad de Datos</h3>
                <p>
                  Los socios restauranteros son responsables de la exactitud de los datos ingresados en Hambre OS, incluyendo 
                  información del menú, niveles de inventario y configuración de programas de fidelidad.
                </p>
                <h3>8.4 Conectividad de Impresoras</h3>
                <p>
                  Hambre OS soporta conexiones de impresoras de red, USB y Bluetooth. Los usuarios son responsables de 
                  asegurar el hardware de impresora compatible y la configuración de red adecuada. Hambre no proporciona 
                  soporte de hardware para impresoras de terceros.
                </p>
                <h3>8.5 Modo Sin Conexión y Sincronización Local</h3>
                <p>
                  Las funciones de modo sin conexión se proporcionan tal cual. Aunque nos esforzamos por garantizar la 
                  sincronización de datos cuando se restaura la conectividad, Hambre no es responsable de ninguna pérdida 
                  de datos u discrepancias que ocurran durante operaciones sin conexión.
                </p>

                <h2>9. Requisitos de Verificación de Repartidores</h2>
                
                <h3>9.1 Requisito de Cumplimiento Legal</h3>
                <p>
                  Hambre requiere que todos los socios de entrega ("Repartidores") proporcionen documentación válida, incluyendo 
                  pero no limitado a un permiso de conducir válido, prueba de seguro de vehículo, documentación de registro de 
                  vehículo y cualquier otra documentación requerida por la ley aplicable, autoridades regulatorias o los 
                  proveedores de seguros de Hambre.
                </p>

                <h3>9.2 Propósito de la Recopilación</h3>
                <p>Dicha documentación se recopila únicamente con los propósitos de:</p>
                <ul>
                  <li>Verificar la elegibilidad legal para realizar servicios de entrega</li>
                  <li>Asegurar el cumplimiento con las leyes y regulaciones aplicables</li>
                  <li>Cumplir con las obligaciones contractuales y de seguro de Hambre</li>
                  <li>Proteger a los usuarios de la plataforma y terceros</li>
                </ul>

                <h3>9.3 Proceso de Verificación</h3>
                <p>
                  La documentación enviada por los Repartidores será revisada para autenticidad, validez y cumplimiento 
                  con los requisitos aplicables.
                </p>

                <h3>9.4 Eliminación de Documentos Después de la Revisión</h3>
                <p>Una vez que la documentación ha sido revisada y verificada:</p>
                <ul>
                  <li>Hambre no retiene copias de los documentos originales subidos;</li>
                  <li>Los archivos sin procesar (incluyendo escaneos, imágenes o PDFs) se eliminan permanentemente de los sistemas activos;</li>
                  <li>Solo se retienen metadatos de verificación limitados.</li>
                </ul>

                <h3>9.5 Obligación Continua</h3>
                <p>
                  Los Repartidores son responsables de asegurar que toda la documentación permanezca válida y actualizada. 
                  Hambre se reserva el derecho de suspender o terminar el acceso a la plataforma si la documentación 
                  expira o es inválida.
                </p>

                <h2>10. Propiedad Intelectual</h2>
                <p>
                  El nombre Hambre, logo y todo el contenido en nuestra plataforma son propiedad de Hambre Ltd o nuestros licenciantes. 
                  No puedes usar, reproducir o distribuir ningún contenido sin nuestro permiso escrito.
                </p>

                <h2>11. Limitación de Responsabilidad</h2>
                <p>
                  En la máxima medida permitida por la ley, Hambre no será responsable de:
                </p>
                <ul>
                  <li>Daños indirectos, incidentales o consecuentes</li>
                  <li>Pérdida de beneficios, datos u oportunidades de negocio</li>
                  <li>Problemas derivados de alimentos o servicio del restaurante</li>
                  <li>Retrasos en entregas fuera de nuestro control razonable</li>
                  <li>Pérdida de datos u discrepancias durante operaciones sin conexión</li>
                  <li>Problemas relacionados con hardware o conectividad de impresoras</li>
                </ul>
                <p>
                  Nuestra responsabilidad total no excederá el monto que pagaste por el pedido relevante o, para 
                  Hambre OS, las tarifas de suscripción pagadas en los 12 meses anteriores.
                </p>

                <h2>12. Indemnización</h2>
                <p>
                  Aceptas indemnizar y mantener a Hambre libre de cualquier reclamación, daño o gasto derivado de 
                  tu incumplimiento de estos Términos o mal uso del Servicio.
                </p>

                <h2>13. Modificaciones a los Términos</h2>
                <p>
                  Podemos modificar estos Términos en cualquier momento. El uso continuado del Servicio después de los cambios 
                  constituye la aceptación de los Términos modificados. Los cambios materiales serán notificados por correo 
                  electrónico o notificación en la plataforma.
                </p>

                <h2>14. Terminación</h2>
                <p>
                  Podemos suspender o terminar tu cuenta por violaciones de estos Términos o a nuestra discreción. 
                  Puedes cerrar tu cuenta en cualquier momento contactándonos.
                </p>

                <h2>15. Ley Aplicable</h2>
                <p>
                  Estos Términos se rigen por las leyes de Inglaterra y Gales. Cualquier disputa estará sujeta a la 
                  jurisdicción exclusiva de los tribunales de Inglaterra y Gales.
                </p>

                <h2>16. Divisibilidad</h2>
                <p>
                  Si alguna disposición de estos Términos se considera inaplicable, las disposiciones restantes 
                  permanecerán en pleno vigor y efecto.
                </p>

                <h2>17. Información de Contacto</h2>
                <p>
                  Para preguntas sobre estos Términos, por favor contáctanos:
                </p>
                <ul>
                  <li>Correo electrónico: <a href="mailto:legal@hambre.app">legal@hambre.app</a></li>
                  <li>Dirección: Hambre Ltd, Londres, Reino Unido</li>
                </ul>
              </>
            ) : (
              <>
                <h2>1. Agreement to Terms</h2>
                <p>
                  By accessing or using the Hambre platform ("Service"), you agree to be bound by these Terms & Conditions 
                  ("Terms"). If you do not agree to these Terms, please do not use our Service.
                </p>

                <h2>2. Description of Service</h2>
                <p>
                  Hambre provides an online platform that connects customers with restaurants for food ordering and delivery. 
                  We act as an intermediary between you and our restaurant partners. We do not prepare food ourselves.
                </p>
                <p>
                  For restaurant partners, we also offer Hambre OS - our Restaurant Operating System which includes 
                  Point of Sale (POS), Kitchen Display System (KDS), inventory management, loyalty programs, end-of-day 
                  reports, printer configuration, and other business management tools.
                </p>

                <h2>3. Account Registration</h2>
                <h3>3.1 Account Creation</h3>
                <p>
                  To use certain features, you must create an account. You agree to provide accurate, current, and complete 
                  information and to update this information to keep it accurate.
                </p>
                <h3>3.2 Account Security</h3>
                <p>
                  You are responsible for maintaining the confidentiality of your account credentials and for all activities 
                  under your account. Notify us immediately of any unauthorised access.
                </p>

                <h2>4. Ordering and Payments</h2>
                <h3>4.1 Placing Orders</h3>
                <p>
                  When you place an order, you make an offer to purchase from the restaurant. The restaurant may accept or 
                  reject your order. Orders are binding once confirmed by the restaurant.
                </p>
                <h3>4.2 Prices and Payments</h3>
                <ul>
                  <li>Prices displayed include VAT where applicable.</li>
                  <li>Delivery fees and service charges are shown before checkout.</li>
                  <li>Payment is processed at the time of order for delivery orders.</li>
                  <li>We accept major credit and debit cards.</li>
                </ul>
                <h3>4.3 Refunds and Cancellations</h3>
                <p>
                  Refunds may be issued for orders not delivered or significantly different from what was ordered. 
                  Cancellation requests must be made promptly and are subject to the restaurant's acceptance.
                </p>

                <h2>5. Delivery</h2>
                <h3>5.1 Delivery Times</h3>
                <p>
                  Estimated delivery times are indicative and not guaranteed. Delays may occur due to traffic, weather, 
                  or other factors beyond our control.
                </p>
                <h3>5.2 Delivery Areas</h3>
                <p>
                  Delivery availability depends on your location and restaurant coverage. You must provide accurate 
                  delivery address information.
                </p>
                <h3>5.3 Failed Deliveries</h3>
                <p>
                  If delivery fails due to incorrect address, recipient unavailability, or other customer-related reasons, 
                  you may not be entitled to a refund.
                </p>

                <h2>6. User Conduct</h2>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the Service for any unlawful purpose</li>
                  <li>Impersonate others or provide false information</li>
                  <li>Interfere with the proper operation of the Service</li>
                  <li>Attempt to gain unauthorised access to any systems</li>
                  <li>Engage in abusive behaviour towards staff, restaurants, or drivers</li>
                  <li>Use the Service for commercial purposes without permission</li>
                </ul>

                <h2>7. Restaurant Partners</h2>
                <p>
                  Restaurants on our platform are independent businesses. They are responsible for:
                </p>
                <ul>
                  <li>Food quality, safety, and hygiene</li>
                  <li>Accuracy of menu descriptions and pricing</li>
                  <li>Compliance with food regulations</li>
                  <li>Handling of allergen information</li>
                </ul>
                <p>
                  Hambre is not liable for issues arising from restaurant food preparation or service.
                </p>

                <h2>8. Hambre OS Terms</h2>
                <h3>8.1 Software Licence</h3>
                <p>
                  Restaurant partners are granted a limited, non-exclusive, non-transferable licence to use Hambre OS 
                  for the duration of their subscription. This licence does not include any ownership rights in the software.
                </p>
                <h3>8.2 Acceptable Use</h3>
                <p>Hambre OS users agree to:</p>
                <ul>
                  <li>Use the system only for legitimate restaurant operation purposes</li>
                  <li>Maintain the security of access credentials</li>
                  <li>Not attempt to reverse engineer or modify the software</li>
                  <li>Not share access with unauthorised individuals or entities</li>
                </ul>
                <h3>8.3 Data Responsibility</h3>
                <p>
                  Restaurant partners are responsible for the accuracy of data entered into Hambre OS, including 
                  menu information, inventory levels, and loyalty program configuration.
                </p>
                <h3>8.4 Printer Connectivity</h3>
                <p>
                  Hambre OS supports network, USB, and Bluetooth printer connections. Users are responsible for 
                  ensuring compatible printer hardware and proper network configuration. Hambre does not provide 
                  hardware support for third-party printers.
                </p>
                <h3>8.5 Offline Mode and Local Sync</h3>
                <p>
                  Offline mode features are provided as-is. While we strive to ensure data synchronisation when 
                  connectivity is restored, Hambre is not liable for any data loss or discrepancies that occur 
                  during offline operations.
                </p>

                <h2>9. Driver Verification Requirements</h2>
                
                <h3>9.1 Legal Compliance Requirement</h3>
                <p>
                  Hambre requires all delivery partners ("Drivers") to provide valid documentation, including but not limited to 
                  a valid driving licence, proof of motor insurance, vehicle registration documentation, and any other documentation 
                  required by applicable law, regulatory authorities, or Hambre's insurance providers.
                </p>

                <h3>9.2 Purpose of Collection</h3>
                <p>Such documentation is collected solely for the purposes of:</p>
                <ul>
                  <li>Verifying legal eligibility to perform delivery services</li>
                  <li>Ensuring compliance with applicable laws and regulations</li>
                  <li>Meeting Hambre's contractual and insurance obligations</li>
                  <li>Protecting platform users and third parties</li>
                </ul>

                <h3>9.3 Verification Process</h3>
                <p>
                  Documentation submitted by Drivers will be reviewed for authenticity, validity, and compliance with applicable requirements.
                </p>

                <h3>9.4 Deletion of Documents After Review</h3>
                <p>Once documentation has been reviewed and verified:</p>
                <ul>
                  <li>Hambre does not retain copies of the original uploaded documents;</li>
                  <li>Raw files (including scans, images, or PDFs) are permanently deleted from active systems;</li>
                  <li>Only limited verification metadata is retained.</li>
                </ul>

                <h3>9.5 Ongoing Obligation</h3>
                <p>
                  Drivers are responsible for ensuring that all documentation remains valid and up to date. 
                  Hambre reserves the right to suspend or terminate access to the platform if documentation expires or is invalid.
                </p>

                <h2>10. Intellectual Property</h2>
                <p>
                  The Hambre name, logo, and all content on our platform are owned by Hambre Ltd or our licensors. 
                  You may not use, reproduce, or distribute any content without our written permission.
                </p>

                <h2>11. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Hambre shall not be liable for:
                </p>
                <ul>
                  <li>Indirect, incidental, or consequential damages</li>
                  <li>Loss of profits, data, or business opportunities</li>
                  <li>Issues arising from restaurant food or service</li>
                  <li>Delivery delays beyond our reasonable control</li>
                  <li>Data loss or discrepancies during offline operations</li>
                  <li>Issues related to printer hardware or connectivity</li>
                </ul>
                <p>
                  Our total liability shall not exceed the amount you paid for the relevant order or, for Hambre OS, 
                  the subscription fees paid in the preceding 12 months.
                </p>

                <h2>12. Indemnification</h2>
                <p>
                  You agree to indemnify and hold Hambre harmless from any claims, damages, or expenses arising from 
                  your breach of these Terms or misuse of the Service.
                </p>

                <h2>13. Modifications to Terms</h2>
                <p>
                  We may modify these Terms at any time. Continued use of the Service after changes constitutes 
                  acceptance of the modified Terms. Material changes will be notified via email or platform notification.
                </p>

                <h2>14. Termination</h2>
                <p>
                  We may suspend or terminate your account for violations of these Terms or at our discretion. 
                  You may close your account at any time by contacting us.
                </p>

                <h2>15. Governing Law</h2>
                <p>
                  These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the 
                  exclusive jurisdiction of the courts of England and Wales.
                </p>

                <h2>16. Severability</h2>
                <p>
                  If any provision of these Terms is found unenforceable, the remaining provisions shall remain in 
                  full force and effect.
                </p>

                <h2>17. Contact Information</h2>
                <p>
                  For questions about these Terms, please contact us:
                </p>
                <ul>
                  <li>Email: <a href="mailto:legal@hambre.app">legal@hambre.app</a></li>
                  <li>Address: Hambre Ltd, London, United Kingdom</li>
                </ul>
              </>
            )}

          </div>
        </div>
      </div>
    </>
  );
}
